import React from "react";
import { deleteData, getData, postData } from "../global/Globalapi"


export const FetchCoupons=async(setcoupon,callback=null)=>{
    try {
       setcoupon([]);
       const res=await getData("/getcoupon")
       console.log("response data", res)
       if(res.data){
        setcoupon(res.data.result);

         if (typeof callback === "function") {
        callback(res.data.result);
          }
       }


    } catch (error) {
        console.log("Error Fetching Coupons",error);
    }
}

export const FetchCategory=async(setcategory)=>{
try{
 setcategory([]);
 const res=await getData('/getcategory')
 console.log("category response",res);
 if(res.data){
   const allCategories = [{ product_type_name: 'All' }, ...res.data.result];
    setcategory(allCategories)
 }
}
catch(error){
 console.log("Error Fetching Data",error);
}
}
export const DeleteCoupon=async(id)=>{
 try {
    const res=await deleteData (`/deletecoupon/${id}`)
    console.log("Deleted",res)
 } catch (error) {
    console.log("Error Deleting Data",error)
 }
}

export const EditCoupon=async(payload)=>{
    try {
      const res=await postData('/editcoupon',payload) 
      console.log("Edit coupon res",res); 
    } catch (error) {
        console.log("Error Editing Data",error)
    }
}

export const CreateCoupon = async (payload) => {
  try {
    const res = await postData('/createcoupon', payload);
    console.log("Coupon created successfully", res);
  } catch (error) {
    console.log("Error creating coupon", error);
    throw error;
  }
};